module.exports = __webpack_public_path__ + "static/media/99157676_283293162839265_245747201064566784_n.797807ed.jpg";